import { useNavigate } from 'react-router-dom';

import inviteAlreadyAccepted from 'assets/invite-already-accepted.png';

import { ROUTES } from 'routes/route.constants';

import InviteFlowLayout from './InviteFlowLayout';

import styles from './InviteFlow.module.scss';

const AlreadyAccepted = () => {
  const navigate = useNavigate();
  const isLoggedIn = Boolean(localStorage.getItem('userObject'));

  const handleContinue = () => {
    navigate(isLoggedIn ? ROUTES.TEAM_HOME : ROUTES.TEAM_LOGIN);
  };

  return (
    <InviteFlowLayout>
      <img
        src={inviteAlreadyAccepted}
        alt="Invitation already accepted"
        className={styles['illustration']}
      />

      <div className={styles['text-group']}>
        <h1 className={styles['screen-title']}>
          Invitation already accepted
        </h1>
        <p className={styles['screen-subtitle']}>
          You already have access to this workspace
        </p>
      </div>

      <button
        type="button"
        onClick={handleContinue}
        className={styles['cta-button']}
      >
        {isLoggedIn ? 'Continue to Dashboard' : 'Continue to Sign In'}
      </button>
    </InviteFlowLayout>
  );
};

export default AlreadyAccepted;
